/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-bind */
import {
  AddCircle,
  AddLinkRounded,
  CreateNewFolder,
  FolderZipRounded,
  SearchRounded,
  UploadFileRounded,
} from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  SwipeableDrawer,
  TextField,
  Tooltip,
} from '@mui/material';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import { Container, Header, Page, TabButton, TabSelection } from './styles';

import {
  getManualsFoldersByUserId,
  getAutomaticsFoldersByUserId,
  getUsersByCompanyIdRequest,
  Guest,
  createFileRequest,
  postFolderZipRequest,
  createMultipleFilesRequest,
  MultipleUpload,
  createZipFileRequest,
} from '../../services/requests';
import fileApi from '../../services/requests/arquivos/fileApi';
import { createLogRequest } from '../../services/requests/app-logs/utils';

import {
  acceptFileTypes,
  getFileTypeCard,
  maxUploadSize,
} from '../../utils/mimeTypes';

import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';
import useArquiveStore from '../../store/arquives';
import useStatusButtonArchives from '../../store/statusButtonArchives';

import { Doc } from '../Reuniao/CriarReuniao/Agenda';

import { LoadingBackdrop } from '../../components/LoadingBackdrop';
import DrawerAddLink from './components/AddLink';
import DrawerCreateFile from './components/CreateFile';
import { FilesList } from './components/FilesList';
import { ViewerFile } from '../../components/ViewerFile';
import useUserStore from '../../store/users';

interface GuestToSelect extends Guest {
  selectedFolder: boolean;
}

export function FolderComponent() {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const setBreadcrumbs = useArquiveStore(state => state.setBreadcrumbs);
  const statusButton = useStatusButtonArchives(
    state => state.statusButtonArchives,
  );
  const setStatusButton = useStatusButtonArchives(
    state => state.setStatusButtonArchives,
  );

  const setUsersInCompany = useUserStore(state => state.setUsersInCompany);
  const searchForFilesAndFoldersAndLinks = useArquiveStore(
    state => state.searchArchives,
  );
  const setSearchForFilesAndFoldersAndLinks = useArquiveStore(
    state => state.setSearchArchives,
  );

  const [searchForUsers, setSearchForUsers] = useState('');
  const [openDrawerCreateFolder, setOpenDrawerCreateFolder] = useState(false);
  const [openDrawerCreateLink, setOpenDrawerCreateLink] = useState(false);
  const [listagemUsers, setListagemUsers] = useState<GuestToSelect[]>([]);
  const [listUsersFiltered, setListUsersFiltered] = useState<Guest[]>([]);
  const [listagemPastasReunioes, setListagemPastasReunioes] = useState<any[]>(
    [],
  );
  const [listagemPastas, setListagemPastas] = useState<any[]>([]);
  const [folderId, setFolderId] = useState('');
  const [openDropdown, setOpenDropdown] = useState<null | HTMLElement>(null);
  const open = Boolean(openDropdown);
  const [loading, setLoading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<Doc>({} as Doc);
  const [openDocViewer, setOpenDocViewer] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [loadingFolder, setLoadingFolder] = useState(false);

  const listManualToFilter = listagemPastas.filter(f =>
    (f.name || f.original_name)
      ?.toUpperCase()
      .includes(searchForFilesAndFoldersAndLinks.toUpperCase()),
  );
  const listManualFiltered =
    searchForFilesAndFoldersAndLinks.length > 0
      ? listManualToFilter
      : listagemPastas;
  const listAutomaticToFilter = listagemPastasReunioes.filter(f =>
    (f.name || f.original_name)
      ?.toUpperCase()
      .includes(searchForFilesAndFoldersAndLinks.toUpperCase()),
  );
  const listAutomaticFiltered =
    searchForFilesAndFoldersAndLinks.length > 0
      ? listAutomaticToFilter
      : listagemPastasReunioes;

  async function loadAutoPastas() {
    try {
      setLoading(true);
      const responseAutoPastas = await getAutomaticsFoldersByUserId(
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (responseAutoPastas?.status === 200) {
        const foundedAutoFiles = responseAutoPastas?.data;

        // console.log('data foundedAutoFiles', foundedAutoFiles);

        const foundedAutoFilesFormatted = foundedAutoFiles?.map((f: any) => ({
          ...f,
          type: getFileTypeCard(f),
        }));

        setListagemPastasReunioes(foundedAutoFilesFormatted);
      }
    } catch (error) {
      console.log('Error loadManualPastas', error);
    } finally {
      setLoading(false);
    }
  }

  const loadUsers = useCallback(async () => {
    try {
      setLoadingUsers(true);
      const response = await getUsersByCompanyIdRequest(
        selectedCompany?.id as string,
        '',
        '',
        '100',
        '',
      );

      if (response?.data?.data?.length > 0) {
        const usersFiltered = response?.data?.data?.filter(
          (userF: any) => userF.id !== user?.id,
        );
        setListagemUsers(usersFiltered);
        // setListUsersFiltered(usersFiltered);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingUsers(false);
    }
  }, [searchForUsers, selectedCompany?.id, user?.id]);

  const loadManualPastas = useCallback(async () => {
    try {
      setLoading(true);
      const isMaster = user?.profile === 'UN1';
      const isInCompany = selectedCompany?.users_ids?.find(
        id => id === user?.doc,
      );

      const responsePastas = await getManualsFoldersByUserId(
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (responsePastas?.status === 200) {
        const foundedFiles = responsePastas?.data;

        const foundedFilesFormatted = foundedFiles?.map((f: any) => ({
          ...f,
          type: getFileTypeCard(f),
        }));

        const listagemPastasFiltradas = foundedFilesFormatted?.filter(
          (f: any) =>
            f?.guests?.some((u: any) => u.id === user?.id) ||
            f?.owner.name === user?.name,
        );

        const listagemPastasPublicas = foundedFilesFormatted?.filter(
          (f: any) => f?.guests.length === 0,
        );

        const difference = _.differenceBy(
          listagemPastasFiltradas,
          listagemPastasPublicas,
          'id',
        );

        const concatAll = listagemPastasPublicas?.concat(difference);

        if (isMaster && !isInCompany) {
          setListagemPastas(foundedFilesFormatted);
        } else {
          setListagemPastas(concatAll);
        }
      }
    } catch (error) {
      console.log('Error loadManualPastas', error);
    } finally {
      setLoading(false);
    }
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    setLoadingUsers(true);
    if (selectedCompany) {
      const delayDebounceFn = setTimeout(() => {
        loadUsers();
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }
  }, []);

  useEffect(() => {
    loadAutoPastas();
    loadManualPastas();
    setBreadcrumbs([
      {
        name: 'Home',
        route: 'hbase-conhecimento',
        id: null,
      },
    ]);
  }, []);

  const handleOpenDrawerCreateFolder = () => {
    setOpenDrawerCreateFolder(true);
    setOpenDropdown(null);
    setSearchForUsers('');
  };

  const handleOpenDrawerCreateLink = () => {
    setOpenDrawerCreateLink(true);
    setOpenDropdown(null);
    setSearchForUsers('');
  };

  const drawerCreateFolder = () => (
    <DrawerCreateFile
      setLoadingFolder={setLoadingFolder}
      openDrawerCreateFolder={openDrawerCreateFolder}
      setOpenDrawerCreateFolder={setOpenDrawerCreateFolder}
      listagemPastas={listagemPastas}
      setListagemPastas={setListagemPastas}
      listagemUsers={listagemUsers}
      searchForUsers={searchForUsers}
      setSearchForUsers={setSearchForUsers}
      folderId={folderId}
      onLoad={loadAutoPastas}
      folderName=""
      loading={loadingUsers}
    />
  );

  const drawerCreateLink = () => (
    <DrawerAddLink
      loading={loadingUsers}
      searchForUsers={searchForUsers}
      setSearchForUsers={setSearchForUsers}
      listagemLink={listagemPastas}
      setListagemLink={setListagemPastas}
      openDrawerCreateLink={openDrawerCreateLink}
      setOpenDrawerCreateLink={setOpenDrawerCreateLink}
      listagemUsers={listagemUsers}
    />
  );

  const handleUploadFile = useCallback(
    async (files: any) => {
      try {
        setLoadingFiles(true);
        if (files?.length === 1) {
          const fileData = files[0];

          // console.log('FILES === 1 => ', files);

          const data = {
            original_name: fileData.name,
            mimetype: fileData.type,
            size: fileData.size,
            key: fileData.name,
            is_downloaded: true,
            is_main: true,
            is_public: true,
            localFile: fileData,
            owner_id: user?.id,
          };

          const fileResponse = await createFileRequest(
            data as any,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (fileResponse?.status === 201) {
            const uploadedFile = {
              ...fileResponse?.data,
              files,
              type: 'file',
            };

            setOpenDropdown(null);

            toast.success('Arquivo salvo com sucesso');

            return setListagemPastas([...listagemPastas!, { ...uploadedFile }]);
          }
        }

        if (files?.length > 1) {
          const folderNameSplited = files[0]?.path?.split('/');

          let folderName = 'null';

          if (folderNameSplited?.length > 1) {
            // eslint-disable-next-line prefer-destructuring
            folderName = folderNameSplited[1];

            // console.log({ folderNameSplited });
          }

          const fileResponse = await createMultipleFilesRequest(
            files,
            user?.id as string,
            folderName,
            'null',
            selectedCompany?.id as string,
          );

          if (fileResponse?.status === 201) {
            const responseMultipleUpload: MultipleUpload = fileResponse?.data;

            setOpenDropdown(null);

            toast.success('Arquivos salvos com sucesso');

            // console.log(
            //   'typeof responseMultipleUpload => ',
            //   responseMultipleUpload,
            // );

            if (responseMultipleUpload.type === 'folder') {
              const uploadedFolder = {
                ...responseMultipleUpload?.data,
                type: responseMultipleUpload.type,
                owner: user?.name,
              };

              return setListagemPastas([
                ...listagemPastas!,
                { ...uploadedFolder },
              ]);
            }

            const newFiles: any = responseMultipleUpload?.data;

            const uploadedFiles = newFiles?.map((dat: MultipleUpload) => ({
              ...dat,
              type: responseMultipleUpload.type,
              owner: { name: user?.name },
            }));

            return setListagemPastas([
              ...listagemPastas!,
              ...(uploadedFiles as any),
            ]);
          }

          // return console.log('FILES multiplo => ', files);
        }

        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } catch (error) {
        console.error('handleUploadFile Error', error);
        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } finally {
        setLoadingFiles(false);
      }
    },
    [listagemPastas, selectedCompany?.id, user],
  );

  const handleOpenFileViewer = useCallback(
    async (fileId: any) => {
      try {
        setOpenDocViewer(true);
        setLoadingPreview(true);
        // setOpenDocViewer(true);

        // setSelectedDoc({
        //   uri: 'https://firebasestorage.googleapis.com/v0/b/ten-app-c8f8d.appspot.com/o/governanca%2Fdocs%2F8c2cad80-a2f5-485b-89f4-8f013be2c29e?alt=media&token=b0370ab4-d6d6-4a4f-819e-b1e27997a41c',
        //   fileType: 'application/pdf',
        //   title: 'Teste Documento',
        // });

        const foundedFile = listagemPastas.filter(f => f.id === fileId);

        // console.log({ fileId });
        // console.log({ foundedFile, listagemPastas });

        if (foundedFile.length > 0) {
          let uri = '';
          if (typeof foundedFile[0].id === 'string') {
            uri = await fileApi.getFileUrl(
              foundedFile[0].url,
              user?.id as string,
              selectedCompany?.id as string,
            );
          } else {
            uri = foundedFile[0].url;
          }
          const fileType = foundedFile[0].mimetype;
          const fileName = foundedFile[0].original_name;

          setSelectedDoc({
            uri,
            fileType,
            title: fileName,
            fileId,
          });

          await createLogRequest({
            name: user?.name as string,
            user_id: user?.id as string,
            company_id: selectedCompany?.id as string,
            local: 'Arquivos',
            action: 'Visualizou',
            description: `Visualizou o documento ${fileName} na base de conhecimento`,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingPreview(false);
      }
    },
    [listagemPastas, selectedCompany?.id, user?.id, user?.name],
  );

  const handleUploadFolderZip = useCallback(
    async (data: any) => {
      try {
        setLoadingFiles(true);

        const selectedFile = data[0];

        const arquiveData = {
          original_name: selectedFile.name,
          mimetype: selectedFile.type,
          size: selectedFile.size,
          key: selectedFile.name,
          is_downloaded: true,
          is_main: false,
          is_public: true,
          localFile: selectedFile,
          folder_id: null,
        };

        const fileResponse = await createZipFileRequest(arquiveData as any);

        const folderZipResponse = await postFolderZipRequest(
          fileResponse as string, // fileKey
          selectedFile.name,
          selectedCompany?.id as string,
          user?.id as string,
          'null',
        );

        if (folderZipResponse?.status === 201) {
          setOpenDropdown(null);

          toast.success(
            'Arquivo enviado com sucesso, os arquivos estão sendo processados e em breve serão listados',
          );
          loadManualPastas();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingFiles(false);
      }
    },
    [loadManualPastas, selectedCompany?.id, user?.id],
  );

  const handleCloseModalPreview = () => {
    setOpenDocViewer(false);
    setSelectedDoc({} as Doc);
  };

  return (
    <Container>
      {loadingFiles && (
        <LoadingBackdrop
          text="Carregando arquivos"
          component=""
          loading={loadingFiles}
        />
      )}
      {loadingFolder && (
        <LoadingBackdrop
          text="Carregando pasta"
          component=""
          loading={loadingFolder}
        />
      )}
      <Header>
        <TabSelection>
          {/* {user?.profile === 'UN1' ||
          user?.profile === 'UN2' ||
          user?.profile === 'UN3' ||
          user?.profile === 'UN4' ? ( */}
          {/* // ) : null} */}
          {/* {user?.profile === 'UN1' ||
          user?.profile === 'UN2' ||
          user?.profile === 'UN3' ? ( */}
          <TabButton
            active={statusButton === 'boards'}
            onClick={() => setStatusButton('boards')}
          >
            Boards
          </TabButton>
          <TabButton
            active={statusButton === 'gerais'}
            onClick={() => setStatusButton('gerais')}
          >
            Gerais
          </TabButton>
          {/* // ) : null} */}
          {/* {user?.profile === 'UN4' && (
            <TabButton
              active={statusButton === 'compartilhadas'}
              onClick={() => setStatusButton('compartilhadas')}
            >
              Compartilhadas
            </TabButton>
          )} */}
        </TabSelection>
        <TextField
          fullWidth
          placeholder="Pesquisar arquivo ou pasta"
          variant="standard"
          onChange={ev => setSearchForFilesAndFoldersAndLinks(ev.target.value)}
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '9px 12px',
          }}
          InputProps={{
            endAdornment: <SearchRounded />,
            disableUnderline: true, //
          }}
        />

        <React.Fragment key="right">
          {statusButton === 'gerais' &&
            (user?.profile === 'UN1' || user?.profile === 'UN2' ? (
              <Button
                variant="contained"
                className="btn-add"
                onClick={event => setOpenDropdown(event.currentTarget)}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '10px',
                  alignItems: 'center',
                  padding: '6px 22px',
                  height: '48px',
                  minWidth: '142px',
                }}
              >
                <AddCircle />
                Adicionar
              </Button>
            ) : null)}
          <Menu
            id="basic-menu"
            anchorEl={openDropdown}
            open={open}
            onClose={() => setOpenDropdown(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
              style: { width: '240px' },
            }}
          >
            <MenuItem
              onClick={handleOpenDrawerCreateFolder}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            >
              <CreateNewFolder sx={{ width: '25px', height: '25px' }} />
              <Box
                sx={{ fontSize: '15px', fontWeight: '500', color: '#000000' }}
              >
                Pasta
              </Box>
            </MenuItem>

            <Dropzone
              onDrop={handleUploadFile}
              accept={acceptFileTypes}
              maxSize={maxUploadSize}
              multiple
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Tooltip
                    title="Arquivos validos .pdf, .xlsx, .xls, .ppt, .pptx, .doc, .docx"
                    placement="left"
                  >
                    <MenuItem
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: 'rgba(0, 0, 0, 0.54)',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      <UploadFileRounded
                        sx={{ width: '25px', height: '25px' }}
                      />
                      {/* <input hidden accept="image/*" multiple type="file" /> */}
                      <Box
                        sx={{
                          fontSize: '15px',
                          fontWeight: '500',
                          color: '#000000',
                        }}
                      >
                        Arquivos
                      </Box>
                    </MenuItem>
                  </Tooltip>
                </div>
              )}
            </Dropzone>
            <Dropzone
              onDrop={handleUploadFolderZip}
              accept={{ 'application/zip': ['.zip'] }}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Tooltip
                    title="Certifique-se de que a pasta que está enviando esteja compactada usando o WinRAR para garantir o correto funcionamento no sistema."
                    placement="left"
                  >
                    <MenuItem
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: 'rgba(0, 0, 0, 0.54)',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      <FolderZipRounded
                        sx={{ width: '24px', height: '24px' }}
                      />

                      <Box
                        sx={{
                          fontSize: '15px',
                          fontWeight: '500',
                          color: '#000000',
                        }}
                      >
                        Pasta zipada
                      </Box>
                    </MenuItem>
                  </Tooltip>
                </div>
              )}
            </Dropzone>

            <MenuItem
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
              onClick={handleOpenDrawerCreateLink}
            >
              <AddLinkRounded sx={{ width: '25px', height: '25px' }} />
              <Box
                sx={{ fontSize: '15px', fontWeight: '500', color: '#000000' }}
              >
                Link Externo
              </Box>
            </MenuItem>
          </Menu>
          <SwipeableDrawer
            onClose={() => setOpenDrawerCreateFolder(false)}
            onOpen={handleOpenDrawerCreateFolder}
            open={openDrawerCreateFolder}
            anchor="right"
          >
            {drawerCreateFolder()}
          </SwipeableDrawer>
          <SwipeableDrawer
            onClose={() => setOpenDrawerCreateLink(false)}
            onOpen={handleOpenDrawerCreateLink}
            open={openDrawerCreateLink}
            anchor="right"
          >
            {drawerCreateLink()}
          </SwipeableDrawer>
        </React.Fragment>
      </Header>

      <Page>
        {loading ? (
          <Box
            marginTop="250px"
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            {statusButton === 'boards' && (
              <Box>
                {/* <Box>
                  <span className="title">
                    Documentos incluídos em reuniões
                  </span>
                </Box> */}
                <FilesList
                  files={listAutomaticFiltered}
                  setFiles={setListagemPastasReunioes}
                  loading={loading}
                  onLoad={loadAutoPastas}
                  handleOpenFileViewer={handleOpenFileViewer}
                  isAutomatic
                />
              </Box>
            )}
            {statusButton === 'gerais' && (
              <Box>
                {/* <Box>
                  <span className="title">Documentos de uso comum</span>
                </Box> */}
                <FilesList
                  files={listManualFiltered}
                  setFiles={setListagemPastas}
                  loading={loading}
                  onLoad={loadManualPastas}
                  handleOpenFileViewer={handleOpenFileViewer}
                />
              </Box>
            )}
            {/* {statusButton === 'compartilhadas' && (
              <Box>
                <Box>
                  <span className="title">
                    Documentos compartilhados comigo
                  </span>
                </Box>
                <FilesList
                  files={listManualFiltered}
                  setFiles={setListagemPastas}
                  loading={loading}
                  onLoad={loadManualPastas}
                  handleOpenFileViewer={handleOpenFileViewer}
                />
              </Box>
            )} */}
          </Box>
        )}
      </Page>
      <ViewerFile
        fileUrl={selectedDoc?.uri}
        loading={loadingPreview}
        onClose={handleCloseModalPreview}
        open={openDocViewer}
        title={selectedDoc?.title}
        fileId={selectedDoc?.fileId}
      />

      {/* <Dialog
        open={openDocViewer}
        onClose={handleCloseModalPreview}
        fullWidth
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        sx={{
          width: '100%',
          height: '100%',
        }}
        PaperProps={{
          sx: {
            height: '100%',
            width: '100%',
            maxHeight: 'none',
            maxWidth: 'none',
            margin: '0',
            borderRadius: '0px',
            backgroundColor: '#1a1a1a',
          },
        }}
      >
        <Box width="100%" height="100%">
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '5px 10px',
              backgroundColor: 'rgb(238, 238, 238)',
            }}
          >
            <Typography
              sx={{
                color: '#000000',
                fontFamily: 'Roboto',
                fontWeight: '500',
                fontSize: '19px',
                lineHeight: '29px',
              }}
            >
              {selectedDoc?.title}
            </Typography>
            <IconButton onClick={handleCloseModalPreview}>
              <CloseRounded sx={{ fontSize: '25px', color: '#000000' }} />
            </IconButton>
          </DialogTitle>
          {loadingPreview ? (
            <Box
              width="100%"
              height="100%"
              padding="20px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CircularProgress />
            </Box>
          ) : (
            <DialogContent
              sx={{
                height: 'fit-content',
                padding: 0,
              }}
            >
              {selectedDoc?.uri && <WaterMark fileUrl={selectedDoc.uri} />}
            </DialogContent>
          )}
        </Box>
      </Dialog> */}
    </Container>
  );
}
